var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"first-message-block"},[_c('el-button',{attrs:{"round":""}},[_vm._v("立即联系")]),_vm._v(" "),_c('span',[_vm._v("177-2473-1490")]),_vm._v(" "),_c('h1',[_vm._v("1500,00 家企业正在使用跑团邦")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad612d2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/FirstMessage.vue
// module id = null
// module chunks = 